import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ImageAsset, useAsset } from '@techstyle/react-assets';
import { injectIntl, defineMessages } from '@techstyle/react-intl';

import { useTrackPromotionClick } from '../../utils/useTrackPromotionClick';
import { TrackPromotionEnterViewport } from '../EnterViewport';

export const defaultMessages = defineMessages({
  emailBadge: {
    id: 'site_home.email_badge',
    defaultMessage: 'Email Notification',
  },
});

const Container = styled.div`
  cursor: pointer;
  position: fixed;
  bottom: 20px;
  left: 20px;
`;

const ImageButton = styled.button`
  cursor: pointer;
  position: relative;
`;

const Image = styled(ImageAsset)`
  width: 64px;
  height: 64px;
  border-radius: 64px;
`;

const RedDot = styled.div`
  z-index: 1;
  background: ${props => props.theme.colors.error};
  width: 14px;
  height: 14px;
  border-radius: 14px;
  position: absolute;
  right: 5px;
`;

const EmailNotificationButton = ({ onClick, intl }) => {
  const assetContainerEmailNotification = useAsset('email_notification', {
    multi: true,
  });
  const { data } = assetContainerEmailNotification;
  const assetsEmailNotification = data ? data.assets : [];
  const dispatchTrackPromotionClicked = useTrackPromotionClick();

  if (!assetsEmailNotification) {
    return null;
  }

  const badgeAsset = assetsEmailNotification.find(
    asset => asset.options.customVars.type === 'email_badge'
  );

  if (!badgeAsset) {
    return null;
  }

  const onButtonClick = e => {
    dispatchTrackPromotionClicked(assetsEmailNotification[0]);
    onClick && onClick(e);
  };

  return (
    <TrackPromotionEnterViewport asset={assetsEmailNotification?.[0]}>
      <Container>
        <ImageButton onClick={onButtonClick}>
          <RedDot />
          <Image
            asset={badgeAsset}
            alt={intl.formatMessage(defaultMessages.emailBadge)}
          />
        </ImageButton>
      </Container>
    </TrackPromotionEnterViewport>
  );
};

EmailNotificationButton.propTypes = {
  onClick: PropTypes.func,
  intl: PropTypes.object,
};

export default injectIntl(EmailNotificationButton);
